interface LogoProps {
  readonly image: string;
  readonly alt: string;
}

export function Logo({ image, alt }: Readonly<LogoProps>): React.JSX.Element | null {
  if (!image) {
    return null;
  }

  return (
    <div className="logo">
      <img src={`/next/images/${image}`} alt={alt} />
    </div>
  );
}
